/** Customer-facing title case for sales orders (URLs stay `sales-orders`). */

export const SALES_ORDER_LABEL = "Sales Order";
export const SALES_ORDERS_LABEL = "Sales Orders";
